const LinkCard=({text, url})=>
{
    return(
        <>
            <a style={{fontFamily:"Inter"}} className="cursor-pointer text-white sm:text-[14px] lg:text-[16px] font-[300] sm:leading-[16px] lg:leading-[24px]" href={url} target="blank">{text}</a>
        </>
    )
}
export default LinkCard